/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.divisionestipospropiedades': 'Divisiones Tipos Propiedades',
  'divisionesTiposPropiedades.agregarDivisionesTiposPropiedades': 'Crear Divisiones Tipos Propiedades',
  'divisionesTiposPropiedades.modificarDivisionesTiposPropiedades': 'Editar Divisiones Tipos Propiedades',
  'divisionesTiposPropiedades.divisionTipoPropiedadId': 'División Tipo Propiedad Id',
  'divisionesTiposPropiedades.empresaId': 'Empresa Id',
  'divisionesTiposPropiedades.divisionTipoPropiedadDescripcion': 'Descripción',
  'divisionesTiposPropiedades.estado': 'Estado',
  'divisionesTiposPropiedades.VerDivisionesTiposPropiedades': 'Ver Divisiones Tipos Propiedades',
  'divisionesTiposPropiedades.propiedad': 'Propiedad',
  'divisionesTiposPropiedades.duplicado': 'La propiedad ya se encuentra registrada, por favor verifique.',
};
